import { FunctionComponent, memo } from 'react';
import { isAdminLayout } from '../../utils';
import { IconLabel } from '../IconLabel/IconLabel';

interface PinnedIconProps {
  isPinnedToTopOfNewsFeed: boolean;
  isPinnedToTopOfStory: boolean;
  color: string;
  source?: string;
  showSeparator?: boolean;
}

export const PinnedIcon: FunctionComponent<PinnedIconProps> = memo(
  ({ isPinnedToTopOfNewsFeed, isPinnedToTopOfStory, color, source, showSeparator }) => {
    if (!isAdminLayout() && (isPinnedToTopOfNewsFeed || isPinnedToTopOfStory)) {
      return (
        <IconLabel
          iconId={'pin'}
          {...((showSeparator || source) && { label: '•' })}
          color={color}
          singleColor
          nonClickable
        />
      );
    }

    return (
      <>
        {isPinnedToTopOfNewsFeed && (
          <IconLabel
            iconId={'pin-n'}
            {...((showSeparator || isPinnedToTopOfStory || source) && { label: '•' })}
            color={color}
            singleColor
            nonClickable
          />
        )}
        {isPinnedToTopOfStory && (
          <IconLabel
            iconId={'pin-m'}
            {...((showSeparator || source) && { label: '•' })}
            color={color}
            singleColor
            nonClickable
          />
        )}
      </>
    );
  }
);
